'use client';
import Image from '@/components/Image';
import { ImageTextIntroductionBlock } from '../types';
import { useValidExposure } from '@/hooks/useValidExposure';
import { useCallback } from 'react';

export function ImageTextIntroduction({
  isWeb,
  content,
  index,
  trackADExp,
}: {
  isWeb: boolean;
  index: number;
  content: ImageTextIntroductionBlock;
  trackADExp: (
    moduleName: string,
    pitsIndex: number,
    pitsJumpType?: string,
    pitsJumpContent?: string,
  ) => void;
}) {
  const {
    pc_image,
    mobile_image,
    pc_width,
    pc_height,
    mobile_width,
    mobile_height,
    title,
    description,
    image_position,
    background,
    module_name,
    mobile_text_align,
  } = content;
  const image = isWeb ? pc_image : mobile_image;
  const width = isWeb ? pc_width : mobile_width;
  const height = isWeb ? pc_height : mobile_height;
  const { ref: validExposureRef } = useValidExposure({
    callback: useCallback(() => {
      trackADExp(module_name, index, '0');
    }, [module_name, index, trackADExp]),
  });
  if (isWeb) {
    return (
      <section
        ref={validExposureRef}
        className={`2xl:py-[80px] lg:py-[60px] 2xl:px-[7.2917vw] lg:px-[70px] flex lg:flex-row flex-col 2xl:gap-[3.3854vw] lg:gap-[32px] ${image_position === 'left' ? '' : 'lg:flex-row-reverse'}`}
        style={{ backgroundColor: background }}
      >
        <div
          className="flex-1/2 relative lg:m-0 m-[40px]"
          style={{
            aspectRatio: `${width}/${height}`,
          }}
        >
          <Image className="w-full" src={image} width={width} height={height} alt={title} />
        </div>
        <div className="flex flex-1/2 flex-col gap-[24px] justify-center lg:m-0 m-[40px] mt-0">
          <h2 className="text-[#282828] text-[32px] leading-[38px] font-bb">{title}</h2>
          <p className="text-[#282828] text-[20px] leading-[30px] font-br">{description}</p>
        </div>
      </section>
    );
  }
  return (
    <section
      ref={validExposureRef}
      className="pt-[47px] pb-[41px] px-[8px]"
      style={{ backgroundColor: background }}
    >
      <div
        style={{
          aspectRatio: `${width}/${height}`,
        }}
      >
        <Image className="w-full" src={image} width={width} height={height} alt={title} />
      </div>
      <div
        className="pt-[24px]"
        style={{
          textAlign: mobile_text_align,
        }}
      >
        <h2 className="text-[#282828] text-[20px] font-bb leading-[24px]">{title}</h2>
        <p className="mt-[8px] text-[#282828] font-br leading-[16px] text-[12px]">{description}</p>
      </div>
    </section>
  );
}
